module.exports = __webpack_public_path__ + "img/Corte.f8c0831f.webp";